import { useEffect } from 'react';
import { Lock } from 'lucide-react';

// Shown instead of the challenge route itself when platformSettings.challengeInternalOnly is on and
// the signed-in account isn't @mathongo.com (see jeeMainPaywall.js's canAccessChallenge) - same
// centered-modal-on-desktop/bottom-sheet-on-mobile shell as JeeMainPaywallSheet, but there's no
// "unlock" action here (soft-launch gate, not a purchase gate), so the only way out is back to the
// dashboard.
export default function ChallengeInternalGateSheet({ open, onClose }) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-end justify-center md:items-center">
      <div className="fixed inset-0 bg-black/40" onClick={onClose} />
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="challengeInternalGateT"
        className="relative z-10 w-full max-w-md rounded-t-3xl bg-[var(--q3-surface-default)] p-6 pb-[calc(24px+env(safe-area-inset-bottom,0px))] shadow-2xl md:rounded-3xl md:p-8"
      >
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--q3-surface-dimmer)] text-[var(--q3-neutral-light)]">
          <Lock className="h-8 w-8" />
        </div>

        <h2 id="challengeInternalGateT" className="text-center text-xl font-bold text-[var(--q3-neutral-default)]">
          Not available yet
        </h2>
        <p className="mt-2 text-center text-sm leading-relaxed text-[var(--q3-neutral-light)]">
          The 99 Percentile Challenge isn&rsquo;t open to everyone just yet - check back soon.
        </p>

        <button
          onClick={onClose}
          type="button"
          className="mt-6 flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-[var(--q3-neutral-default)] font-semibold text-[var(--q3-neutral-default_inverted)] cursor-pointer"
        >
          Back to dashboard
        </button>
      </section>
    </div>
  );
}
